<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.receiptDetailEdit')" type="confirm" width="60%" @confirm="confirm">
    <vxe-form :data="detail" border span="8" title-align="center" title-background>
      <vxe-form-item field="order.no" title="business.label.receiptOrderNo"/>
      <vxe-form-item field="supplier.name" span="16" title="business.label.supplier"/>
      <vxe-form-item field="item.no" title="business.label.itemNo"/>
      <vxe-form-item field="item.name" title="business.label.itemName"/>
      <vxe-form-item field="owner.name" title="business.label.owner"/>
      <vxe-form-item field="pack.specification" title="business.label.specification"/>
      <vxe-form-item field="pack.uom" title="business.label.uom"/>
      <vxe-form-item field="pack.factor" title="business.label.factor"/>
      <vxe-form-item field="lot.no" title="business.label.lot"/>
      <vxe-form-item field="lot.productionDate" title="business.label.productionDate"/>
      <vxe-form-item field="lot.validUntil" title="business.label.validUntil"/>
      <vxe-form-item field="storageRoom.name" title="business.label.storageRoom">
        <template #default>
          <vxe-input v-model="detail.storageRoom.name" :editable="false" style="width: 100%" @clear="onStorageRoomChange([])" @click="onStorageRoomSelect"/>
          <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
        </template>
      </vxe-form-item>
      <vxe-form-item field="container.no" title="business.label.containerNo">
        <template #default>
          <vxe-input v-model="detail.container.no" :editable="false" style="width: 100%" @clear="onContainerChange([])" @click="onContainerSelect"/>
          <container-modal ref="containerModal" @change="onContainerChange"/>
        </template>
      </vxe-form-item>
      <vxe-form-item field="invoiceQuantity" title="business.label.invoiceQuantity">
        <template #default>
          <vxe-number-input v-model="detail.invoiceQuantity" :min="1" style="width: 100%"/>
        </template>
      </vxe-form-item>
    </vxe-form>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import api from '@/api'
import ContainerModal from '@/views/modal/ContainerModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { ReceiptDetail } from '@/api/dto/order/ReceiptOrder'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Container } from '@/api/dto/common/Container'
import { BaseObject } from '@/api/dto/BaseObject'

export default {
  components: { ContainerModal, StorageRoomModal },
  data() {
    return {
      visible: false,
      loading: false,
      detail: new ReceiptDetail()
    }
  },
  methods: {
    open(record) {
      this.visible = true
      this.detail = new ReceiptDetail(BaseObject.merge(record, 'detail'))
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open()
    },
    onStorageRoomChange(values) {
      this.detail.storageRoom = new StorageRoom(values[0])
    },
    onContainerSelect() {
      this.$refs.containerModal.open({ available: true, physical: true, 'storageRoom.id': this.detail.storageRoom.id })
    },
    onContainerChange(values) {
      this.detail.container = new Container(values[0])
    },
    confirm() {
      this.loading = true
      post(api.receivingReceiverModify, { type: 'normalInboundReceiver' }, this.detail.toJSONObject()).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>